import React from "react";
import "./Footer.css";

export default function Footer() {
  return (
    <footer>
      Coded by <strong>Novia Hoyte</strong> and open-sourced on{" "}
      <a
        href="https://github.com/nhoyte/dictionary"
        target="_blank"
        rel="noreferrer"
      >
        GitHub
      </a>
    </footer>
  );
}
